import {
  RETRIEVE_TOPIC_PREVIEW_BEGIN,
  RETRIEVE_TOPIC_PREVIEW_SUCCESS,
  RETRIEVE_TOPIC_PREVIEW_FAILURE, KEY_FOR_KEYWORDS_JSON, KEY_FOR_CATEGORIES,
  KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

export function retrieveTopicPreview(props = {}) {
  return dispatch => {
    dispatch({
      type: RETRIEVE_TOPIC_PREVIEW_BEGIN,
    });
    const formData = new FormData();
    formData.append(KEY_FOR_CATEGORIES,props.categories);
    formData.append(KEY_FOR_KEYWORDS_JSON,JSON.stringify(props.keywordsJSON));
    formData.append(KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE,props.earliestHistoricalDataDate);
    const url = apiEndPoints.topicpreview.RETRIEVE_TOPIC_PREVIEW;
    return new Promise((resolve, reject) => {
      const doRequest = http.post(url,formData);
      doRequest.then(
        res => {
          dispatch({
            type: RETRIEVE_TOPIC_PREVIEW_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: RETRIEVE_TOPIC_PREVIEW_FAILURE,
          });
          reject(err);
        },
      );
    });
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RETRIEVE_TOPIC_PREVIEW_BEGIN:
      return {
        ...state,
        retrieveTopicPreviewBegin: true,
        retrieveTopicPreviewSuccess: false,
        retrieveTopicPreviewFailure: false,
      };
    case RETRIEVE_TOPIC_PREVIEW_SUCCESS:
      return {
        ...state,
        retrieveTopicPreviewBegin: false,
        retrieveTopicPreviewSuccess: true,
        topicPreviewPosts: action.data.data.posts,
        topicPreviewTotalPostsCount: action.data.data.totalCount,
        topicPreviewTotalCommentsCount: action.data.data.commentCount,
        topicPreviewEstimatedProcessingTimeInHours: parseFloat(action.data.data.estimatedProcessingTimeInHours)
      };
    case RETRIEVE_TOPIC_PREVIEW_FAILURE:
      return {
        ...state,
        retrieveTopicPreviewBegin: false,
        retrieveTopicPreviewFailure: true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/topics/redux/retrieveTopicPreview.js